module.exports = __webpack_public_path__ + "img/20190820135001875.b99d3530.jpg";